import { SITE_ORIGIN } from '@/navigation/constants'
import type { LandingLocale } from '@/navigation/localeConstants'

import type { DemoLocale, LandingDemo } from './catalog'
import { demoTranscript, iso8601Duration } from './catalog'

function toDemoLocale(locale: LandingLocale): DemoLocale {
    return locale === 'en' ? 'en' : 'es'
}

function absoluteAssetUrl(pathOrUrl: string) {
    if (pathOrUrl.startsWith('https://') || pathOrUrl.startsWith('http://')) return pathOrUrl
    return `${SITE_ORIGIN}${pathOrUrl}`
}

export function buildVideoObjectJsonLd(demo: LandingDemo, locale: LandingLocale) {
    const lang = toDemoLocale(locale)
    const primary = demo.landscape ?? demo.portrait
    const encodings = [demo.portrait, demo.landscape]
        .filter((rendition): rendition is NonNullable<typeof rendition> => Boolean(rendition))
        .flatMap(rendition => [
            {
                '@type': 'MediaObject',
                contentUrl: absoluteAssetUrl(rendition.hevc),
                encodingFormat: 'video/mp4',
                width: rendition.width,
                height: rendition.height,
            },
            {
                '@type': 'MediaObject',
                contentUrl: absoluteAssetUrl(rendition.webm),
                encodingFormat: 'video/webm',
                width: rendition.width,
                height: rendition.height,
            },
        ])

    return {
        '@context': 'https://schema.org',
        '@type': 'VideoObject',
        name: demo.name[lang],
        description: demo.description[lang],
        thumbnailUrl: absoluteAssetUrl(primary.poster),
        uploadDate: demo.uploadDate,
        duration: iso8601Duration(demo.durationSeconds),
        contentUrl: absoluteAssetUrl(primary.webm),
        encoding: encodings,
        transcript: demoTranscript(demo, lang),
        inLanguage: lang === 'en' ? 'en-US' : 'es-ES',
        isFamilyFriendly: true,
    }
}
